import React, { useState } from 'react';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../component/call-to-action-button/call-to-action-button';
import { createPollOperation } from '../operations/create-poll-operation';

interface CreatePollDialogProps {
  closeDialog: () => void;
  initialPollName?: string;
  onPollCreated?: (pollName: string) => Promise<void>;
}

export const CreatePollDialog: React.FC<CreatePollDialogProps> = ({
  closeDialog,
  initialPollName = '',
  onPollCreated,
}) => {
  const [pollName, setPollName] = useState(initialPollName);
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = async () => {
    if (onPollCreated) {
      await onPollCreated(pollName);
    } else {
      await createPollOperation(pollName, setLoading, closeDialog);
    }
  };

  return (
    <div>
      <EditText
        title={'שם המשוב'}
        onChange={setPollName}
        value={pollName}
        maxLength={100}
      />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'יצירת משוב'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
